import { ACTION_TYPES } from "../../constants/protocol";
import { backendDispatches } from "./backendDispatches";
import { PROGRAM_TITLES } from "./mainMessageBoxHandler";
import { programHandler } from "./programHandler";
import { reportMasterControlFailure } from "../../components/store/slices/commandFailureSlice";
import { fromInputTemp } from "../helpers";

// Temperatures arrive as the operator typed them; the device state and the
// request below this point are in °C.
const programInCelsius = (program, state, temp, data, isF) => {
  if (state !== "on") return { temp, data };
  if (program === "instantHeat" || program === "constantTemp") {
    return { temp: fromInputTemp(temp, isF), data };
  }
  if (program === "heatingSchedule") {
    return {
      temp,
      data: { start: data.start, end: data.end, inputTemp: fromInputTemp(data.inputTemp, isF) },
    };
  }
  return { temp, data };
};

export const loopMachinesHandler = (
  program,
  state,
  scope,
  type,
  typedTemp,
  typedData,
  isF,
  zones,
  swt,
  switchData,
  dispatch,
  unSelectedIndividualMachineHandler,
  unselectSpecificLocationMachinesHandler,
  handleResetAllSelectBySwitch,
  handleResetAllSelectByLocation,
  messageBoxHandler,
  switchDataE
) => {
  const { temp, data } = programInCelsius(program, state, typedTemp, typedData, isF);
  let machineIds = [];
  if (scope === "switch") {

    Object.keys(switchData).forEach((location) => {
      Object.keys(switchData[location]).forEach((el) => {
        if (switchData[location][el]?.deviceMac) {
    

          if (switchData[location][el].isSelected) {
            machineIds.push(switchData[location][el].deviceMac);
            if (state === "on") {
              dispatch(
                unSelectedIndividualMachineHandler({ location, machine: el })
              );
            }
            programHandler(
              dispatch,
              program,
              state,
              scope,
              type,
              temp,
              data,
              location,
              el,
              null,
              zones,
              swt,
              messageBoxHandler
            );
          }
        } else {

          Object.keys(switchData[location][el]).forEach((machine) => {
            if (switchData[location][el][machine].isSelected) {
              machineIds.push(switchData[location][el][machine].deviceMac);
              dispatch(
                unselectSpecificLocationMachinesHandler({
                  location,
                  machine,
                })
              );
              programHandler(
                dispatch,
                program,
                state,
                scope,
                type,
                temp,
                data,
                location,
                machine,
                el,
                zones,
                swt,
                messageBoxHandler
              );
            }
          });
        }
      });
    });
    if (machineIds.length !== 0 && state === "on") {
      dispatch(handleResetAllSelectBySwitch());
      backendDispatches(
        ACTION_TYPES.MASTER_CONTROL,
        program,
        machineIds,
        temp,
        data,
        swt
      ).catch(reportMasterControlFailure(dispatch, swt, machineIds));
      messageBoxHandler(
        "applied",
        scope,
        type,
        PROGRAM_TITLES[program] ?? program
      );
    } else if (state === "on") {
      messageBoxHandler(
        "selectNone",
        scope,
        type,
        PROGRAM_TITLES[program] ?? program
      );
    } else {
      messageBoxHandler(state, scope, type, program);
    }
  } else {
    if (switchDataE[scope]?.isSpecificLocation) {
      Object.keys(switchDataE[scope]?.subLocations).forEach((subLocation) => {
        Object.keys(switchData[subLocation]).forEach((el) => {
          if (switchData[subLocation][el]?.deviceMac) {
            if (switchData[subLocation][el].isSelected) {
              machineIds.push(switchData[subLocation][el].deviceMac);
              if (state === "on") {
                dispatch(
                  unSelectedIndividualMachineHandler({
                    location: subLocation,
                    machine: el,
                  })
                );
            }
              
              programHandler(
                dispatch,
                program,
                state,
                subLocation,
                type,
                temp,
                data,
                subLocation,
                el,
                null,
                zones,
                swt,
                messageBoxHandler
              );
            }
          }
        });
      });
    } else {
      Object.keys(switchData[scope]).forEach((el) => {
        if (switchData[scope][el]?.deviceMac) {
          if (switchData[scope][el].isSelected) {
            machineIds.push(switchData[scope][el].deviceMac);
            if (state === "on") {
              dispatch(
                unSelectedIndividualMachineHandler({ location: scope, machine: el })
              );
            }
            programHandler(
              dispatch,
              program,
              state,
              scope,
              type,
              temp,
              data,
              scope,
              el,
              null,
              zones,
              swt,
              messageBoxHandler
            );
          }
        }

      });
    }

    if (machineIds.length !== 0 && state === "on") {
      dispatch(handleResetAllSelectByLocation());
      backendDispatches(
        ACTION_TYPES.LOCAL_MASTER_CONTROL,
        program,
        machineIds,
        temp,
        data,
        swt
      ).catch(reportMasterControlFailure(dispatch, swt, machineIds));
      messageBoxHandler(
        "applied",
        scope,
        type,
        PROGRAM_TITLES[program] ?? program
      );
    } else if (state === "on") {
      messageBoxHandler(
        "selectNone",
        scope,
        type,
        PROGRAM_TITLES[program] ?? program
      );
    } else {
      messageBoxHandler(state, scope, type, program);
    }
  }
};
